import { GenderEnum } from "@/generated/graphql-hooks";

export const modelGenders = {
  [GenderEnum.Female]: "女KOL",
  [GenderEnum.Male]: "男KOL",
};
